import React, { useMemo, useCallback } from 'react'
import { ColDef, ColGroupDef, GetRowIdParams } from 'ag-grid-enterprise'
import CustomAgGrid from '../../../../../shared/components/custom/Grid/CustomAgGrid'
import { CustomReportTableSection } from '../../../../../redux/context/customReports/typesSection'
import { buildTransposedRowData } from '../grid/utils/transposedRowData'
import { buildTransposedColumnDefs } from '../grid/utils/transposedColumnDefs'
import { useRowFilteringCategories } from '../../hooks/useRowFilteringCategories'
import printTheme from './printTheme'

interface PrintTableSectionTransposedProps {
  section: CustomReportTableSection
}

const PrintTableSectionTransposed: React.FC<PrintTableSectionTransposedProps> = ({ section }) => {
  const { variables, categories = [] } = section
  const { isExternalFilterPresent, doesExternalFilterPass } = useRowFilteringCategories(false, variables)
  const getRowId = useCallback((params: GetRowIdParams) => params.data?.categoryId || '', [])

  const { rowData, columnDefs } = useMemo(() => {
    const rows = buildTransposedRowData(categories)
    const cols = buildTransposedColumnDefs({ variables, rows })
    const stripMinWidth = (col: ColDef | ColGroupDef): ColDef | ColGroupDef => {
      if ('children' in col && col.children) {
        return { ...col, children: col.children.map(stripMinWidth) }
      }
      return { ...(col as ColDef), minWidth: 0 }
    }
    return { rowData: rows, columnDefs: cols.map(stripMinWidth) }
  }, [variables, categories])

  return (
    <CustomAgGrid
      theme={printTheme}
      domLayout="autoHeight"
      rowData={rowData}
      columnDefs={columnDefs}
      getRowId={getRowId}
      isExternalFilterPresent={isExternalFilterPresent}
      doesExternalFilterPass={doesExternalFilterPass}
      suppressGroupRowsSticky
      animateRows={false}
      defaultColDef={{
        suppressHeaderMenuButton: true,
        sortable: false,
        filter: false,
        resizable: false
      }}
    />
  )
}

export default React.memo(PrintTableSectionTransposed)
